import { AxiosResponse } from "axios";
import { getSequenceAnswersBodyType } from "../types/Answer";
import { setContentReadBodyType, setContentReadParamsType } from "../types/Questionnaire";
import { getApi, ParamsType, postApi } from "./resonanceApi";

export enum SequenceApiUrlsEnum {
  POST_CONTENT_READ = 'studies/{study_id}/users/{user_id}/sequences/{sequence_id}/contents/{content_id}/read',
  GET_SEQUENCE_ANSWERS = 'studies/{study_id}/users/{user_id}/sequences/{sequence_id}/getanswers',
  SET_SEQUENCE_DONE = 'studies/{studyId}/users/{userId}/sequences/{sequenceId}/done',
  SET_COMPONENT_DONE = 'studies/{studyId}/users/{userId}/sequences/{sequenceId}/sequenceComponents/{sequenceComponentId}/done',
  GET_USER_SCORES = 'studies/{studyId}/users/{userId}/sequences/scores', 
}
export interface UserScore {
  id: number;
  userSequenceId: number;
  sequenceId: number;
  sequenceComponentId: number;
  questionnaireId: number;
  doneAt: string | null;
  score: number | null;
  recurrenceType: "daily" | "weekly" | "fortnightly" | "monthly" | "yearly" | null;
}

export interface SetComponentDoneResponse {
  success: boolean;
  userSequenceComponentId: number;
  sequenceId: number;
  sequenceComponentId: number;
  questionnaireId: number | null;
  score: number | null;
  doneAt: string;
  allDone: boolean;
  userSequenceId: any;
}

export function setSequenceContentRead(params: setContentReadParamsType, body: setContentReadBodyType) {
  const url = SequenceApiUrlsEnum.POST_CONTENT_READ;
  return postApi(url, params, body)
}

export async function getSequenceAnswers(params: ParamsType): Promise<AxiosResponse<getSequenceAnswersBodyType>> {
  const url = SequenceApiUrlsEnum.GET_SEQUENCE_ANSWERS;
  return getApi<getSequenceAnswersBodyType>(url, params);
}

export function setSequenceDone(params: ParamsType): Promise<AxiosResponse> {
  const url = SequenceApiUrlsEnum.SET_SEQUENCE_DONE;
  return postApi(url, params, {});
}
export function setSequenceComponentDone(
  params: { studyId: number; userId: number; sequenceId: string; sequenceComponentId: number },
  totalScore: number | null
): Promise<AxiosResponse<SetComponentDoneResponse>> {
  const url = SequenceApiUrlsEnum.SET_COMPONENT_DONE;
  return postApi(url, params, { totalScore });
}

export async function getUserScores(params: ParamsType): Promise<AxiosResponse<UserScore[]>> {
  const url = SequenceApiUrlsEnum.GET_USER_SCORES;
  return getApi<UserScore[]>(url, params);
}